module.exports = __webpack_public_path__ + "img/getting-started-thumb.4cb75432.png";